import useRegulatoryBody from "../../../hooks/useRegulatoryBody";
import { Select } from "../../ui/Select"
import React from "react"

export const SelectRegulatoryBody = React.memo(({label, name, value, country, onChange, required, disabled, isReport}) => {

    const regulatoryBodies = useRegulatoryBody(country);

    return (
        <div className="form-group">
            <Select
                label={label}
                name={name}
                isReport={isReport}
                required={required}
                value={value}
                onChange={onChange}
                disabled={disabled}
                options={regulatoryBodies.map((value)=>({ value: value.RegulatoryAuthority, display_value: value.RegulatoryAuthority }))}
            />
        </div>
    )
})